import { render } from "./LanguagePicker.vue?vue&type=template&id=2caf9602&scoped=true"
import script from "./LanguagePicker.vue?vue&type=script&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&lang=js"

import "./LanguagePicker.vue?vue&type=style&index=0&id=2caf9602&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2caf9602"]])

export default __exports__